import { TFunction } from 'i18next';
import { MenuConfig } from '../lib/components';
import {
  AccountIconSvg,
  CompaniesIconSvg,
  LaunchIconSvg,
  LockIconSvg,
  PayrollIconSvg,
  PuzzleIconSvg
} from '../lib/icons';

export const companySubmenuConfig = (
  t: TFunction,
  companyCount: number,
  departmentCount: number,
  costCenterCount: number,
  groupCount: number,
  openInvoicePortal: () => unknown,
  hris?: boolean,
  companyLogo?: boolean,
  isBonusStandalone?: boolean
): MenuConfig => {
  return [
    {
      title: t('common:COMPANY'),
      icon: CompaniesIconSvg,
      isActive: ({ pathname }) => /\/company\/settings/.test(pathname),
      link: `/company/`,
      config: [
        {
          title: t('company:CORE_DATA'),
          isActive: ({ pathname }) => /\/company\/settings\/core-data/.test(pathname),
          link: `/company/settings/core-data`
        },
        {
          title: t('company:CONTACT_DATA'),
          isActive: ({ pathname }) => /\/company\/settings\/contact-data/.test(pathname),
          link: `/company/settings/contact-data`
        },
        {
          title: t('company:COMPANY_LOGO'),
          isActive: ({ pathname }) => /\/company\/settings\/company-logo/.test(pathname),
          link: `/company/settings/company-logo`,
          hidden: !companyLogo
        },
        {
          title: t('company:MENU_TITLE_LOCATIONS', { count: companyCount }),
          isActive: ({ pathname }) => /\/company\/settings\/locations/.test(pathname),
          link: `/company/settings/locations`
        },
        {
          title: t('company:MENU_TITLE_DEPARTMENTS', { count: departmentCount }),
          isActive: ({ pathname }) => /\/company\/settings\/departments/.test(pathname),
          link: `/company/settings/departments`
        },
        {
          title: t('company:MENU_TITLE_COST_CENTERS', { count: costCenterCount }),
          isActive: ({ pathname }) => /\/company\/settings\/cost-centers/.test(pathname),
          link: `/company/settings/cost-centers`
        },
        {
          title: t('company:MENU_TITLE_GROUPS', { count: groupCount }),
          isActive: ({ pathname }) => /\/company\/settings\/groups/.test(pathname),
          link: `/company/settings/groups`
        },
        {
          title: t('common:PAYROLL_EXPORT'),
          isActive: ({ pathname }) => /\/company\/settings\/payroll/.test(pathname),
          link: `/company/settings/payroll`,
          hidden: !isBonusStandalone
        }
      ]
    },
    {
      title: t('company:PAYMENT'),
      icon: PayrollIconSvg,
      isActive: ({ pathname }) => /\/company\/payment/.test(pathname),
      link: `/company/payment`,
      config: [
        {
          title: t('common:GENERAL'),
          isActive: ({ pathname }) => /\/company\/payment\/general$/.test(pathname),
          link: `/company/payment/general`
        },
        {
          title: t('company:PAYMENT_address'),
          isActive: ({ pathname }) => /\/company\/payment\/address$/.test(pathname),
          link: `/company/payment/address`
        },
        {
          title: t('company:PAYMENT_VIEW'),
          secondaryIcon: LaunchIconSvg,
          onClick: openInvoicePortal
        }
      ]
    },
    {
      title: t('company:INTEGRATIONS'),
      icon: PuzzleIconSvg,
      isActive: ({ pathname }) => /\/company\/integrations/.test(pathname),
      link: `/company/integrations`,
      hidden: !hris,
      config: [
        {
          title: t('company:HRIS_PAUSE_SYNC'),
          isActive: ({ pathname }) => /\/company\/integrations\/hris-pause/.test(pathname),
          link: `/company/integrations/hris-pause`,
          hidden: !hris
        }
      ]
    },
    {
      title: t('company:SECURITY'),
      icon: LockIconSvg,
      isActive: ({ pathname }) => /\/company\/security/.test(pathname),
      link: `/company/security`,
      config: [
        {
          title: t('auth:APP_LOGIN'),
          isActive: ({ pathname }) => /\/company\/security\/app$/.test(pathname),
          link: `/company/security/app`
        },
        {
          title: t('auth:PLATFORM_LOGIN'),
          isActive: ({ pathname }) => /\/company\/security\/platform$/.test(pathname),
          link: `/company/security/platform`
        },
        {
          title: t('company:DATA_PROTECTION'),
          isActive: ({ pathname }) => /\/company\/security\/general$/.test(pathname),
          link: `/company/security/general`
        }
      ]
    },
    {
      title: t('account:MY_ACCOUNT'),
      icon: AccountIconSvg,
      isActive: ({ pathname }) => /\/company\/account/.test(pathname),
      link: `/company/account`,
      config: [
        {
          title: t('account:PASSWORD'),
          isActive: ({ pathname }) => /\/company\/account\/password$/.test(pathname),
          link: `/company/account/password`
        },
        {
          title: t('account:MANAGE_2FA'),
          isActive: ({ pathname }) => /\/company\/account\/twofactor$/.test(pathname),
          link: `/company/account/twofactor`
        }
      ]
    }
  ];
};
